import { render, staticRenderFns } from "./SecretStorages.vue?vue&type=template&id=3091a65d&scoped=true"
import script from "./SecretStorages.vue?vue&type=script&lang=js"
export * from "./SecretStorages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3091a65d",
  null
  
)

export default component.exports